import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import _ from "lodash";
import Aqp from "../../../libs/mk-react-aqp";

import {fetchMeetUsers, resetMeetUsers} from "../../../creators/meet.users";

import Title from "../../components/Title";
import {Button} from "../../components/Button";
import {LoadingBar, PageLoader} from "../../components/Loader";
//import Dropdown from "../../components/Dropdown";
//import Toggle from "../../components/Toggle";
import AskForLocalisation from "./components/AskForLocalisation";
import MeetHeader from "./components/MeetHeader";
import Modal from "../../components/Modal";
import MeetMemberCard from "./components/MeetMemberCard";
import Pagination from "../../components/Pagination";
import createLink from "../../../libs/createLink";
import Subscribe from "../../components/Subscribe";
import ModalEncourageSignup from "../../components2/encourageSignup/EncourageSignup";


let mapping = {
    // 'location': 'localisationmmm',
    'lookingFor': 'recherche',
    /*'ageMinOne': 'age-minimum-1',
    'ageMinTwo': 'age-minimum-2',
    'ageMaxOne': 'age-maximum-1',
    'ageMaxTwo': 'age-maximum-2',*/
    'trancheAgeMinOne': 'age-minimum-1',
    'trancheAgeMinTwo': 'age-minimum-2',
    'trancheAgeMaxOne': 'age-maximum-1',
    'trancheAgeMaxTwo': 'age-maximum-2',
    'isCertified': 'certification',
    'hasPhotos': 'photos',
    'hasVideos': 'videos',
    'locationDistance': 'distance',
    'sort': 'trier-par',
};

class UsersMeet extends React.Component {
    constructor(props) {
        super(props);

        let city = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_city`) || null;
        if(city){
            city = JSON.parse(city);
        }

        this.usersFilter = {
            appearInDating: true,
            sort: "-createdAt",
            isOnline: false,
            limit: 28,
            locationDistance: 125,
            latitude: "0",
            longitude: "0",
            lookingFor: [],
            /* ageMinOne: 18,
             ageMaxOne: 123,
             ageMinTwo: 18,
             ageMaxTwo: 123,*/
            trancheAgeMinOne: 0,
            trancheAgeMaxOne: 8,
            trancheAgeMinTwo: 0,
            trancheAgeMaxTwo: 8,
            isCertified: false,
            hasPhotos: false,
            hasVideos: false,
            isUsingGeo: false,
            page: this.props.match.params.page || 1
        };

        let infosGeo = {};

        if(city){
            infosGeo = {
                longitude : city.longitude,
                latitude : city.latitude
            }
        }

        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page', 'appearInDating'],
            currentLink: createLink("dating"),
            filterDefault: this.usersFilter
        });

        this.usersFilter = {...this.usersFilter, ...this.aqp.query, page: this.props.match.params.page || 1, ...infosGeo};

        if(!_.get(this.props.currentUser, "customer.subscribed") && this.usersFilter.page > 1){
            this.usersFilter = {
                ...this.usersFilter,
                page : 1
            }
            this.handleDisplayMessageNotPremium();
        }

        this.state = {
            usersFilter : this.usersFilter,
            toggleFilters: false,
            closerFilter: false,
            askForLocalisation: false,
            togglePremium : false,
            signupModal : false
        };

        this.getUsers = this.getUsers.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDisplayMessageNotPremium = this.handleDisplayMessageNotPremium.bind(this);

        this.getUsers(this.state.usersFilter);
    }

    componentWillUnmount() {
        this.props.resetMeetUsers();
        this.setState({usersFilter: this.usersFilter, topicsFilter: this.topicsFilter})
    }

    getUsers(filter) {
        let query = {...filter};
        //console.log(query);
        this.props.fetchMeetUsers(this.aqp.set(query));
        //console.log(this.aqp.query);
    }

    handleToggleFilters(value) {
        value = value ? value : !this.state.toggleFilters;
        this.setState({toggleFilters: value});
    }

    handleSort(name, value) {
        let usersFilter = {...this.state.usersFilter, [name]: value};
        this.setState({usersFilter});
        this.getUsers(usersFilter);
    }

    handleChangePage(page) {
        let isAbo = _.get(this.props.currentUser, 'customer.subscribed') || false;
        if(isAbo){
            let usersFilter = {...this.state.usersFilter, page};
            this.setState({usersFilter});
            this.getUsers(usersFilter);
            window.scrollTo(0, 0);
        }
        else{
            this.handleDisplayMessageNotPremium();
        }
    }

    handleDisplayMessageNotPremium(){
        console.log("non membre");
        if(_.get(this.props.currentUser, '_id')){
            this.setState({togglePremium : true});
        }
        else{
            this.setState({signupModal : true});
        }


    }

    handleSubmit(filters) {
        this.setState({usersFilter : {...filters, page : 1}});
        this.getUsers({...this.state.usersFilter, ...filters, page : 1});
        // this.handleToggleFilters();
    }

    render() {
        let lookingFor = Array.isArray(this.state.usersFilter.lookingFor) ? this.state.usersFilter.lookingFor : [this.state.usersFilter.lookingFor];
        let totalPage = Math.ceil(this.props.usersTotal / this.state.usersFilter.limit);
        return (
            <div className={"column"}>
                <Modal toggle={this.state.togglePremium} handleClose={() => this.setState({togglePremium: false})}>
                    {/*<div className={"modal-no-premium"}>
                        <p>Pour avoir accès à la totalité des membres correspondant à cette recherche, il faut être membre VIP</p>
                        <Button className={`mx-8 cta-premium`}
                                onClick={() => console.log("modal premium")}
                                size={"small"}
                                btnStyle={"primary-reverse"}
                                content={"devenez VIP"}/>
                    </div>*/}
                    <Subscribe />
                </Modal>

                <ModalEncourageSignup
                    toggle={this.state.signupModal}
                    handleClose={() => this.setState({signupModal: false}) }
                />


                <div className="meet-btn-group row wrap">
                    <Title heading={"heading-1"} display={"display-2"}>Voissanautes qui cherchent une rencontre</Title>
                    <div className="row align-center">
                        <Button className={`mx-8`}
                                active={this.state.toggleFilters}
                                onClick={() => this.handleToggleFilters()}
                                size={"small"}
                                btnStyle={"primary-reverse"}
                                icon={this.state.toggleFilters ? "minimize" : "plus"}
                                content={"Filtres"}/>
                        {/*<Dropdown align="right filter-list" activableComponent={(
                            <Button className={"sort-by"}
                                    size={"small"}
                                    icon={"chevron-down"}
                                    iconSide={"right"}
                                    content={"Trier par"}/>
                        )}>
                            <ul className="dropdown-menu">
                                <li className="menu-item">
                                    Date d'inscription <Toggle
                                    isToggled={this.state.usersFilter.sort === "-createdAt"}
                                    onToggle={() => this.handleSort("sort", this.state.usersFilter.sort === "-createdAt" ? "createdAt" : "-createdAt")}/>
                                </li>
                                {/*<li className="menu-item">
                                    Profil en ligne <Toggle
                                    isToggled={this.state.usersFilter.isOnline}
                                    onToggle={() => this.handleSort("isOnline", !this.state.usersFilter.isOnline)}/>
                                </li>*/}
                        {/* </ul>
                        </Dropdown>*/}
                    </div>
                </div>
                <MeetHeader
                    toggleFilters={this.state.toggleFilters}
                    handleToggleFilters={this.handleToggleFilters}
                    usersFilter={{...this.state.usersFilter, lookingFor}}
                    onSubmit={this.handleSubmit}
                />
                <Modal toggle={this.state.askForLocalisation}
                       handleClose={() => this.setState({askForLocalisation: false})}>
                    <AskForLocalisation
                        handleClose={() => this.setState({askForLocalisation: false})}/>
                </Modal>
                {this.props.usersInitialized && this.props.usersLoading && (
                    <LoadingBar />
                )}
                {!this.props.usersInitialized ? (
                    <PageLoader/>
                ) : (
                    <div className="meet-grid">
                        {this.props.users.map((item, index) => (
                            <MeetMemberCard
                                key={index}
                                {...item}
                                usersLoading={this.props.usersLoading}
                            />
                        ))}
                        {this.props.users.length === 0 && (
                            <div className="no-content">Aucun profil trouvé</div>
                        )}
                    </div>
                )}
                {this.props.usersInitialized && this.props.users.length >= 1 && <Pagination
                    currentPage={this.state.usersFilter.page}
                    pagesCount={totalPage}
                    {...this.aqp.queryUrl(this.state.usersFilter, mapping)}
                    handleChangePage={this.handleChangePage}
                />}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        users: state.meetUsers.data,
        usersLoading: state.meetUsers.loading,
        usersInitialized: state.meetUsers.initialized,
        usersTotal: state.meetUsers.total,
        currentUser : state.currentUser.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchMeetUsers,
    resetMeetUsers,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UsersMeet);